export const REGEX_ZIPCODE = /^\d{3} \d{2}$|^\d{3}\d{2}$/;
export const REGEX_ORGNR = /^\d{6}[-]\d{4}$/;
export const REGEX_PHONE_NUMBER = /^(0)[1-9]+[0-9]*$/;
